import { Component } from '@angular/core';

@Component({
  selector: 'app-bps-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './bps-dashboard.component.html',
  styleUrl: './bps-dashboard.component.scss'
})
export class BpsDashboardComponent {

}
